import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import {
  LiquidityForecastCaptureResultDto,
  LiquidityIntelligenceAlertDto,
  LiquidityIntelligenceSummaryDto
} from '../../../_core/_model/machine-learning';
import { MachineLearningAdminService } from '../../../_core/_services/machine-learning-admin.service';
import { NotificationService } from '../../../_core/_services/notification.service';

@Component({
  selector: 'app-admin-ml-liquidity',
  standalone: false,
  templateUrl: './admin-ml-liquidity.html',
  styleUrl: './admin-ml-liquidity.css'
})
export class AdminMlLiquidity implements OnInit {
  loading = false;
  captureLoading = false;
  error = '';
  horizonHours = 24;
  summary: LiquidityIntelligenceSummaryDto | null = null;
  alerts: LiquidityIntelligenceAlertDto[] = [];
  lastCapture: LiquidityForecastCaptureResultDto | null = null;

  constructor(
    private mlService: MachineLearningAdminService,
    private notify: NotificationService
  ) {}

  ngOnInit(): void { this.load(); }

  load(): void {
    this.loading = true;
    this.error = '';
    const horizon = Math.min(168, Math.max(1, Number(this.horizonHours) || 24));
    this.horizonHours = horizon;
    forkJoin({
      summary: this.mlService.getLiquiditySummary(horizon),
      alerts: this.mlService.getLiquidityAlerts()
    }).subscribe({
      next: result => {
        this.summary = result.summary.data;
        this.alerts = result.alerts.data || [];
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.error = error.error?.error?.details || error.error?.message || error.message || 'Unable to load liquidity intelligence.';
        this.loading = false;
      }
    });
  }

  capture(): void {
    this.captureLoading = true;
    this.mlService.captureLiquidityForecasts().subscribe({
      next: response => {
        this.lastCapture = response.data;
        this.notify.showSuccess(response.message || 'Liquidity forecasts captured.', 'Success');
        this.load();
      },
      error: error => this.notify.showError(error?.error?.error?.details || error?.error?.message || 'Unable to capture liquidity forecasts.', 'Error'),
      complete: () => this.captureLoading = false
    });
  }

  classificationClass(value?: string | null): string {
    switch ((value || '').toLowerCase()) {
      case 'balanced': return 'text-bg-success';
      case 'watch': return 'text-bg-warning text-dark';
      case 'critical': return 'text-bg-danger';
      case 'insufficientdata': return 'text-bg-secondary';
      default: return 'text-bg-light text-dark border';
    }
  }

  alertClass(value?: string | null): string {
    return (value || '').toLowerCase() === 'critical' ? 'alert-danger' : 'alert-warning';
  }

  gapClass(gap: number): string { return gap > 0 ? 'text-danger' : gap < 0 ? 'text-success' : 'text-muted'; }
}
